module.exports = __webpack_public_path__ + "static/media/check_light.eafd9a73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox/check_light.svg
// module id = 481
// module chunks = 0